module.exports = __webpack_public_path__ + "media/images/contest-vote-title@2x-cdadca36b39c3ea13ea26daa13db0a4d.png";